import { takeLatest } from 'redux-saga/effects'
import { DELETE_TEMPLATE_SAGA } from 'src/store/types/templatePhrases'
import deleteTemplate from './deleteTemplate'

export function* deleteTemplateSaga() {
  yield takeLatest(DELETE_TEMPLATE_SAGA, deleteTemplate)
}
